export * from './localStorage';
export * from './sessionStorage';
export * from './webStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-webstorage/dist/decorators/index.js
// module id = 83
// module chunks = 0